// HomePage.js - FIXED VERSION
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import './HomePage.css';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import AddTruckDetails from '../../Components/AddTruckDetails/AddTruckDetails';
import TodayList from '../../Components/TodayList/TodayList';
import Reports from '../../Components/Reports/Reports';
import Freight from '../../Components/Freight/Freight';
import Vehicle from '../../Components/Vehicle/Vehicle';
import Vendor from '../../Components/Vendor/Vendor';
import Meeting from '../../Components/Meetings/Meetings';
import Transactions from '../../Components/Transactions/Transactions';
import GenerateBill from '../../Components/GenerateBill/GenerateBill';
import config from '../../config';
import Business from '../../Components/Business/Business';
import ReviseBill from '../../Components/ReviseBill/ReviseBill';
import Chat from '../../Components/Chat/Chat';
import useAuth from "../../Auth/useAuth";
import ChatNotification from '../../Components/ChatNotification/ChatNotification';
import UserManagement from '../../Components/UserManagement/UserManagement';
import Profile from '../../Components/Profile/Profile';
import OrderBook from '../../Components/OrderBook/OrderBook';
import Task from '../../Components/Task/Task';
import Approval from '../../Components/Approval/Approval';

axios.defaults.baseURL = `${config.BASE_URL}`;

const HomePage = () => {
  const { selectedChat, setSelectedChat, receivedMsg } = useAuth();
  const location = useLocation();
  const [currentComponent, setCurrentComponent] = useState(null);
  const navigate = useNavigate();

  // Memoize component mapping to prevent recreation on every render
  const componentMap = useMemo(() => ({
    '/home': <AddTruckDetails />,
    '/today-list': <TodayList />,
    '/reports': <Reports />,
    '/freight': <Freight />,
    '/vehicle': <Vehicle />,
    '/vendor': <Vendor />,
    '/meetings': <Meeting />,
    '/transactions': <Transactions />,
    '/generate-bill': <GenerateBill />,
    '/business': <Business />,
    '/revise-bill': <ReviseBill />,
    '/chat': <Chat />,
    '/list-users': <UserManagement />,
    '/profile': <Profile />,
    '/order-book': <OrderBook />,
    '/task': <Task />,
    '/approval': <Approval />
  }), []);

  // Handle component selection based on pathname
  useEffect(() => {
    const path = location.pathname;
    const matchingKey = Object.keys(componentMap).find(key => 
      path === key || (key === '/home' && path.startsWith('/home/'))
    );
    
    setCurrentComponent(matchingKey ? componentMap[matchingKey] : null);
  }, [location.pathname, componentMap]);

  // Clear selected chat when navigating away from chat
  useEffect(() => {
    if (selectedChat && location.pathname !== '/chat') {
      setSelectedChat(null);
    }
  }, [location.pathname, selectedChat, setSelectedChat]);

  // Memoize notification display logic to prevent unnecessary re-calculations
  const shouldShowNotification = useMemo(() => {
    if (!receivedMsg) return false;
    
    // Don't show notification if no chat is selected
    if (!selectedChat) return true;
    
    // Don't show notification if not on chat page
    if (location.pathname !== '/chat') return true;
    
    // Don't show notification if message is from current chat participant
    if (selectedChat.participants?.includes(receivedMsg.senderId)) {
      return false;
    }
    
    return true;
  }, [selectedChat, location.pathname, receivedMsg]);

  return (
    <div className="Home">
      <Navbar />
      <Sidebar />
      {currentComponent}
      
      {shouldShowNotification && (
        <div className="chat-notification">
          <ChatNotification />
        </div>
      )}
    </div>
  );
};

export default HomePage;